import { useEffect } from 'react';

// eslint-disable-next-line no-alert
const handleWindowBeforeUnload = () => window.confirm();

export const useAvoidBeforeUnload = () => {
  useEffect(() => {
    window.onbeforeunload = handleWindowBeforeUnload;
    return () => {
      window.onbeforeunload = null;
    };
  }, []);
};
